export const timeService = {
    getCurrentTime() {
        return new Date().toLocaleString('en-GB', { timeZone: 'Europe/London' });
    }
};